import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import "./main.css";
import { faCircleCheck, faXmark } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
class StatusPopup extends Component {
  render() {
    return (
      <div className="main-popup">
        <div className="popup-style popup-container ">
          <div
            className="justify-content-end d-flex p-1"
            onClick={this.props.closePopup}
          >
            <FontAwesomeIcon icon={faXmark}></FontAwesomeIcon>
          </div>
          <div className="justify-content-center d-flex">
            <FontAwesomeIcon
              icon={this.props.icon}
              className={this.props.className}
              style={{ width: "35px", height: "35px" }}
            ></FontAwesomeIcon>
          </div>
          <div className="font-weight-bold mb-3 mt-3 mr-5 ml-5">
            {this.props.message}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(mapStateToProps, {})(StatusPopup));
